import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Pipe({
	name: "selectsTranslation",
})
export class SelectsTranslationPipe implements PipeTransform {
	constructor(public translateService: TranslateService) {}

	transform(items): any {
		for (let item of items) {
			item.label = this.translateService.instant(item.label);
		}
		return items;
	}
}
